// extracted by mini-css-extract-plugin
export var container = "_9u-0";
export var icon = "_9u-1";
export var text = "_9u-2";